import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=56101db3&"
import script from "./Boutique.vue?vue&type=script&lang=js&"
export * from "./Boutique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56101db3')) {
      api.createRecord('56101db3', component.options)
    } else {
      api.reload('56101db3', component.options)
    }
    module.hot.accept("./Boutique.vue?vue&type=template&id=56101db3&", function () {
      api.rerender('56101db3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Boutique.vue"
export default component.exports